import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(() => ({
    button: {
        width: '100%',
        border: '2px dashed #d1d5db',
        borderRadius: '8px',
        padding: '12px',
        color: '#4b5563',
        textTransform: 'none',
        fontWeight: 500,
        '&:hover': {
            borderColor: '#2dd4bf',
            backgroundColor: '#f0fdfa',
            color: '#0d9488',
        },
    },
}));

interface AddFolderButtonProps {
    onClick: () => void;
    label?: string;
}

export const AddFolderButton: React.FC<AddFolderButtonProps> = ({ onClick, label = 'Add Folder' }) => {
    const classes = useStyles();
    return (
        <Button onClick={onClick} className={classes.button} startIcon={<AddIcon />}>
            {label}
        </Button>
    );
};
